import { OnboardingRouteRedirect } from '../../components';

export default function Step7FamilyRedirect() {
  return <OnboardingRouteRedirect to="/(onboarding)/step-6-family" />;
}
